// extracted by mini-css-extract-plugin
export default {"content":"StatusPage_content__dmh+k","text":"StatusPage_text__JJmQL","block":"StatusPage_block__iyEF1"};